module.exports = __webpack_public_path__ + "static/media/proj2.markdown.573d0210.md";